import React, { useCallback, useEffect, useRef, useState } from "react";
import Collapsible from "react-collapsible";
import "../../../../../Assets/Styles/PasswordInput.scss";
import axios from "axios";
import { Config } from "../../../../../Config";

const PasswordInput = (props) => {
  const [PlaceholderIsShown, setPlaceholderIsShown] = useState(true);
  const [TypeIsPassword, setTypeIsPassword] = useState(true);

  // the following state is only used for password hints when the prop HasHints
  // is set to true
  const [HintsIsOpen, setHintsIsOpen] = useState(false);
  const Timer = useRef(null);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleInputChange = () => {
    let Password = document.getElementById(props.Id + "-input").value;
    if (props.ApiPassValidation && !!Password) {
      if (Timer.current) {
        clearTimeout(Timer.current);
      }
      Timer.current = setTimeout(async () => {
        await fetchPasswordValidation(Password);
      }, 500);
    }
    removeStateClassNames(false);
    props.SetHasMadeChanges(true);
    if (Password.length <= 0) {
      setPlaceholderIsShown(true);
      document.getElementById(props.Id).classList.remove("filled-input");

      if (props.HasHints) {
        validatePassword(Password, true); // validation of the entered password
      }
    } else {
      setPlaceholderIsShown(false);
      document.getElementById(props.Id).classList.add("active-row");
      document.getElementById(props.Id).classList.add("filled-row");
      document.getElementById(props.Id).classList.add("filled-input");

      if (props.HasHints) {
        validatePassword(Password, false); // validation of the entered password
      }
    }
  };

  // removes active and error classNames from the parent element
  const removeStateClassNames = useCallback(
    (WillCloseHints) => {
      document.getElementById(props.Id).classList.remove("error-shown");
      document.getElementById(props.Id).classList.remove("active-row");
      document.getElementById(props.Id).classList.remove("filled-row");
      document
        .getElementById(props.Id + "-lock")
        .classList.remove("active-icon");
      if (WillCloseHints) {
        setHintsIsOpen(false);
      }
    },
    [HintsIsOpen]
  );

  const addActiveState = useCallback(() => {
    document.getElementById(props.Id + "-lock").classList.add("active-icon");
    document.getElementById(props.Id).classList.add("active-row");
  }, [HintsIsOpen]);

  const handleOpenCollapsible = useCallback(
    (EventType) => {
      if (EventType === "open") {
        setHintsIsOpen(true);
        if (props.ShowHints) {
          props.IsShowingHints(true);
        }
      } else {
        setHintsIsOpen(false);
        if (props.ShowHints) {
          props.IsShowingHints(false);
        }
      }
    },
    [HintsIsOpen]
  );

  useEffect(() => {
    if (props.ShowHints) {
      handleOpenCollapsible("open");
    }
  }, [props.ShowHints]);

  // Each password policy item has 3 states:
  // wrong(red), unverified(grey), correct(green)
  const validatePassword = (Password, IsEmpty) => {
    if (!IsEmpty) {
      // 2) validation the length to be at least 8 characters
      if (Password.length < 8) {
        document.getElementById("policy-2").classList.remove("correct");
      } else {
        document.getElementById("policy-2").classList.remove("wrong");
        document.getElementById("policy-2").classList.add("correct");
      }
      // 3) validating containing at least one capital letter
      let CapitalLetterRegEx = /(?=.*[A-Z])/g;
      if (Password.match(CapitalLetterRegEx)) {
        document.getElementById("policy-3").classList.add("correct");
        document.getElementById("policy-3").classList.remove("wrong");
      } else {
        document.getElementById("policy-3").classList.remove("correct");
      }
      // 4) validationg at least one digit
      let DigitRegex = /[\d]{1}/;
      if (Password.match(DigitRegex)) {
        document.getElementById("policy-4").classList.add("correct");
        document.getElementById("policy-4").classList.remove("wrong");
      } else {
        document.getElementById("policy-4").classList.remove("correct");
      }
      // 5) validating containing at least one special character
      let SpecialCharRegEx = /^(?=.*[@#$%^!?&+=]).*$/;
      if (Password.match(SpecialCharRegEx)) {
        document.getElementById("policy-5").classList.add("correct");
        document.getElementById("policy-5").classList.remove("wrong");
      } else {
        document.getElementById("policy-5").classList.remove("correct");
      }
    } else {
      for (let i = 1; i < 6; i++) {
        document.getElementById("policy-" + i).classList.remove("correct");
        document.getElementById("policy-" + i).classList.remove("wrong");
      }
    }
  };

  const handleChangeInutType = () => {
    setTypeIsPassword(!TypeIsPassword);
  };

  // Make sure new password is not the same as the old one
  const fetchPasswordValidation = (Password) => {
    const data = {
      password: Password,
    };
    let ApiPath = "/api/profile/int-check-password";
    if (props.Token) {
      data["token"] = props.Token;
      ApiPath = "/api/profile/ext-check-password";
    }
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + ApiPath,
      data: data,
    };
    if (!props.Token) {
      Req["headers"] = {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      };
    }
    // 1) validating the password to not be the old/previous password
    axios(Req)
      .then((Res) => {
        console.log(Res);
        document.getElementById("policy-1").classList.add("correct");
        document.getElementById("policy-1").classList.remove("wrong");
      })
      .catch((Err) => {
        if (Err.response.status === 409) {
          document.getElementById("policy-1").classList.remove("correct");
          document.getElementById("policy-1").classList.add("wrong");
        }
      });
  };

  return (
    <div className="password-input-wrapper">
      {HintsIsOpen && props.HasHints ? (
        <div
          className="outline"
          onClick={() => removeStateClassNames(true)}
        ></div>
      ) : null}
      <section className="row-input" id={props.Id}>
        <i className="feather-lock" id={props.Id + "-lock"}></i>
        {PlaceholderIsShown ? (
          <p className="input-placeholder">{props.Placeholder}</p>
        ) : null}
        <input
          type={TypeIsPassword ? "password" : "text"}
          id={props.Id + "-input"}
          className="password-input"
          onChange={() => handleInputChange()}
          onFocus={() => addActiveState()}
          autoComplete={
            props.AutoComplete ? props.AutoComplete : "current-password"
          }
          onBlur={() => removeStateClassNames(false)}
          onClick={() => setHintsIsOpen(true)}
        />
        <i
          className={TypeIsPassword ? "feather-eye" : "feather-eye-off"}
          onClick={() => handleChangeInutType()}
        ></i>
        <p className="error-message">{props.ErrorMessage}</p>
      </section>
      {props.HasHints ? (
        <Collapsible
          open={HintsIsOpen}
          transitionTime={200}
          onOpen={() => handleOpenCollapsible("open")}
          onClose={() => handleOpenCollapsible("close")}
          trigger={<div id={props.Id + "-hint-trigger"}></div>}
        >
          <section className="password-hints">
            <span className="hint-row" id="policy-1">
              <i className="feather-check-circle"></i>
              {props.LangData ? (
                <p>{translateText("pwd_validation_old_pass")}</p>
              ) : (
                <p>Should not be your old/previous password.</p>
              )}
            </span>
            <span className="hint-row" id="policy-2">
              <i className="feather-check-circle"></i>
              {props.LangData ? (
                <p>{translateText("pwd_validation_char_count")}</p>
              ) : (
                <p>At least 8 characters</p>
              )}
            </span>
            <span className="hint-row" id="policy-3">
              <i className="feather-check-circle"></i>
              {props.LangData ? (
                <p>{translateText("pwd_validation_capital_letter")}</p>
              ) : (
                <p>At least one capital letter</p>
              )}
            </span>
            <span className="hint-row" id="policy-4">
              <i className="feather-check-circle"></i>
              {props.LangData ? (
                <p>{translateText("pwd_validation_one_digit")}</p>
              ) : (
                <p>At least one digit</p>
              )}
            </span>
            <span className="hint-row" id="policy-5">
              <i className="feather-check-circle"></i>
              {props.LangData ? (
                <p>{translateText("pwd_validation_special_char")}</p>
              ) : (
                <p>At least one special character (@#$%^!?&+=)</p>
              )}
            </span>
          </section>
        </Collapsible>
      ) : null}
    </div>
  );
};

export default PasswordInput;
